import CustomButton, {OutlinedButton} from 'components/CustomButton'
import {useState} from 'react'
import Input from '../../../components/form/Input'
import CustomMessage from "../../../components/CustomMessage";

const CampaignShiftForm = ({addShiftInfo, shift, isEdit = false, changeModal}) => {
  const [editWarning, setEditWarning] = useState(true)

  return (
    <div className="relative">
      {editWarning && isEdit && (
        <div role="alert" className="absolute top-0 bottom-0 left-0 right-0 z-10 flex flex-col justify-center">

          <div className="bg-white border p-4 rounded-md shadow-md">
            <CustomMessage messageType="warning" message="Warning!  This action might affect multiple appointments associated with
              this shift."/>
            <div className="flex space-x-4 justify-center mt-4">
              <OutlinedButton onClick={() => changeModal()}>
                View Bookings
              </OutlinedButton>
              <CustomButton onClick={() => setEditWarning(false)}>
                Proceed Anyway
              </CustomButton>
            </div>
          </div>
        </div>
      )}
      <div className={`${editWarning && isEdit ? 'blur-sm' : ''}`}>
        <Input
          type="text"
          color="blue"
          disabled={editWarning && isEdit}
          placeholder="Shift Name"
          value={shift.name}
          onChange={(e) => {
            addShiftInfo('name', e.target.value, shift)
          }}
        />
        <Input
          disabled={editWarning && isEdit}
          type="time"
          color="blue"
          placeholder="Start Time"
          value={shift.start_time}
          onChange={(e) => {
            addShiftInfo('start_time', e.target.value, shift)
          }}
        />
        <Input
          disabled={editWarning && isEdit}
          type="time"
          color="blue"
          placeholder="End Time"
          value={shift.end_time}
          onChange={(e) => {
            addShiftInfo('end_time', e.target.value, shift)
          }}
        />
      </div>
      {/* )} */}
    </div>
  )
}

export default CampaignShiftForm
